import {
	Anchor,
	Flex,
	Popover,
	Select,
	SelectProps,
	Text,
} from '@mantine/core';
import { FC, useEffect, useRef } from 'react';
import { SlQuestion } from 'react-icons/sl';

interface Props extends SelectProps {
	tooltip?: { content: string };
}

export const AppSelect: FC<Props> = (props) => {
	const ref = useRef<HTMLInputElement>(null!);

	useEffect(() => {
		if (!ref.current) return;
		if (props.value) return;

		ref.current.value = '';
	}, [props.value]);

	return (
		<Select
			{...props}
			ref={ref}
			label={
				props.tooltip ? (
					<Flex
						w="100%"
						justify="space-between"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}
					>
						<Text>{props.label}</Text>
						<Popover width={300}>
							<Popover.Target>
								<Anchor
									c="black"
									lh={0}
									onClick={(e) => {
										e.preventDefault();
									}}
								>
									<SlQuestion />
								</Anchor>
							</Popover.Target>
							<Popover.Dropdown>
								<Text size="md">{props.tooltip.content}</Text>
							</Popover.Dropdown>
						</Popover>
					</Flex>
				) : (
					props.label
				)
			}
		/>
	);
};
